module.exports = __webpack_public_path__ + "ebb13fa5a9a44f3de93063d07a8cb388.svg";